/** Normaliza telefone para E.164 (apenas dígitos, + no início) */
export function normalizePhone(value) {
  if (!value || typeof value !== 'string') return '';
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.length <= 2) return `+55${digits}`;
  return digits.startsWith('55') ? `+${digits}` : `+55${digits}`;
}
